export default {
  free: {
    stripePlan: true,
    illustration: 'tag',
    name: 'Free',
    subheading: 'Access scite data for free',
    usecase: 'See if an article has been supported or contrasted anywhere you read literature online.',
    price: 0,
    features: [
      'See how an article has been talked about wherever you read online',
      '1 scite Report per month',
      '1 Visualization per month',
      '7 day free access to Premium features'
    ],
    featureCopy: [
      { header: 'scite Reports', content: ['See how over 100m publications have been supported, replicated, disputed, criticized, debunked and more', 'Access one scite Report per month'] },
      { header: 'Visualizations', content: ['Discover how articles cite each other', 'Access one Visualization per month'] },
      { header: 'Search', content: ['Find publications using generic search terms'] },
      { header: 'scite Browser Extension', content: ['See how papers have been cited anywhere you are reading research online'] },
      { header: 'Other', content: ['7 day free access to all Premium features'] }
    ],
    CTA: 'Get Started',
    nextPlan: 'premium'
  },
  premium: {
    stripePlan: true,
    illustration: 'lab',
    name: 'Premium',
    subheading: 'USD / month, Billed annually',
    usecase: 'Explore how groups of articles are cited and stay up to date when new citations are published.',
    price: 12.00,
    monthlyPrice: 20.00,
    annualPrice: 144,
    featureHeader: 'Includes all features including:',
    features: [
      'Unlimited scite Reports',
      'Unlimited visualizations',
      `Unlimited Custom Dashboards with up to ${CONFIG.defaultDashboardDOILimits.premium} DOIs`,
      'Unlimited Reference Checks',
      'Unlimited Alerts',
      'Unlimited Saved Search Alerts with up to 1000 DOIs',
      '30% Student discount available'
    ],
    featureCopy: [
      { header: 'scite Reports', content: ['See how over 100m publications have been supported, replicated, disputed, criticized, debunked and more', 'Unlimited scite Reports per month'] },
      { header: 'Visualizations', content: ['Discover how articles cite each other', 'Unlimited Visualization per month'] },
      { header: 'Advanced Search', content: ['Find the highest quality publications by searching for literature based on supporting and contrasting citations they have received', 'Order results and search based on title, abstract, authors, journals, and publication year', 'Access aggregation filters such as top authors, editorial notices, affiliations, and publication types.'] },
      { header: 'scite Browser Extension', content: ['See how papers have been cited anywhere you are reading research online'] },
      { header: 'Dashboards', content: ['Evaluate any group of publications with custom dashboards', 'Unlimited dashboards (with up to 1,000 publications each)'] },
      { header: 'Reference Check', content: ['Upload a manuscript to understand the quality of its references'] },
      { header: 'Alerts', content: ['Stay up to date by setting an alert for when a paper, author, institution, journal, search or custom dashboard receives new citations or publications', 'Unlimited alerts'] },
      { header: 'Other', content: ['Export data as csv', 'Organization-wide and a 30% student discount available'] }
    ],
    CTA: 'Upgrade Now'
  },
  group: {
    illustration: 'lab',
    name: 'Groups',
    subheading: 'For groups up to 100 users',
    usecase: 'Get scite for a group of researchers at a discount.',
    features: [
      'Seat-based Discounts',
      'Commercial API, Data Access, and Evaluation services',
      'Custom Authentication and Integrations',
      'Priority Support'
    ],
    featureCopy: [
      { header: 'Group Discounts', content: ['Get any of our plans at a discount', 'Discounts available depending on the size of your group'] },
      { header: 'Give access to your group', content: ['Group-wide access to any of our plans', 'Get a single invoice for your group'] },
      { header: 'Training & Support', content: ['Get customized scite training', 'Priority Support'] },
      { header: 'Data & Integration', content: ['Custom Authentication and Integrations', 'API and Data Access'] }
    ],
    CTA: 'Request a quote'
  },
  organization: {
    illustration: 'institution',
    name: 'University & Corporate',
    subheading: 'Built for universities, pharmaceutical companies, and other research institutions',
    usecase: 'scite pricing is based on the number of faculty, students, and staff at an institution. We offer organization-wide annual licenses with volume-based discounts. Contact us at sales@scite.ai to request a quote or get a demo.',
    features: [
      'Organization-wide License',
      'Saved Search Alerts (> 1k DOIs)',
      'Organization and Research Dashboards (> 5k DOIs)',
      'Commercial API, Data Access, and Evaluation services',
      'Custom Authentication and Integrations including Link Resolver support',
      'Priority Support',
      'Free Trial available'
    ],
    featureCopy: [
      { header: 'scite Reports', content: ['Give your organization access to the worlds largest database of citation classifications and statements', 'Unlimited scite Reports per month'] },
      { header: 'Citation Statement Search', content: ['Direcly search over 1b citation statements to find expert analyses and opinions on all subjects', 'Unlimited access to Citation Statement Search'] },
      { header: 'Advanced Search', content: ['Access the only way to search publications by how they are cited'] },
      { header: 'Visualizations', content: ['Let researchers evaluate how articles cite each other', 'Unlimited Visualization per month'] },
      { header: 'Dashboards', content: ['Evaluate your research outputs with custom dashboards', 'Unlimited dashboards (supporting up to 5k publications each)'] },
      { header: 'Reference Check', content: ['Improve the quality of your research outputs by allowing researchers to check the quality of their manuscripts'] },
      { header: 'Alerts', content: ['Help your researchers stay up to date by receiving email alerts whenever their research gets cited', 'Unlimited alerts'] },
      { header: 'Data & Integration', content: ['Custom Authentication and Integrations', 'Loginless and registration free usage', 'API and Data Access', 'Link Resolver Support'] },
      { header: 'Other', content: ['COUNTER Compliant Usage Statistics', 'Priority Support', 'Free organization-wide trial available'] }
    ],
    CTA: 'Book a Demo'
  },
  integrate: {
    illustration: 'integrate',
    name: 'Integrate',
    subheading: 'For publishers and research tools',
    usecase: 'Give your users better insight into your publications and drive traffic to your platform.',
    features: [
      'Display scite Badges on your site',
      'Index your content with us'
    ],
    featureCopy: [
      { header: 'Display badges on your site', content: ['Help your users evaluate a publications credibility and quality', 'Integrate scite data into your articles and literature search experience with out badge', 'Join Wiley, Pubmed, EuropePMC, Research Square, Scielo, and more publishers who integrate scite data'] },
      { header: 'Index your content', content: ['Find out how your publications are supporting or contrasting other works', 'Drive thousands of users to your publications every month'] },
      { header: 'Help support your authors and enhance the quality of your submissions', content: ['Integrate scite Reference Check into your submission process', 'Show your authors exactly how their references have been cited by others and whether those references have been supported, contrasted, or retracted'] },
      { header: 'Use scite as a scientific encyclopedia', content: ['Link keywords and specific phrases to the scite Citation Statement search to help your readers/users see what the scientific literature says about any research topic or product'] }
    ],
    CTA: 'Contact Us'
  },
  data: {
    illustration: 'search-citations',
    name: 'Data',
    subheading: 'For building on scite',
    usecase: "Leverage the world's largest source of Citation Statements. Advanced services and access to our unique data.",
    featureCopy: [
      { header: 'scite API & Data Dumps', content: ['Access scite data to enhance your research evaluation and analysis.'] },
      { header: 'Bibliometric Services', content: ['Get custom analysis of your research outputs', 'Work with us on using scite data to enhance your research products'] },
      { header: 'Ranking & Evaluation', content: ['Work with us to understand how scite data can help your research output evaluation and ranking process'] },
      { header: 'Insights', content: ['Understand how anything has been discussed in scientific literature from authors and publications to institutions, research assets, and topics'] }
    ],
    CTA: 'See what we offer'
  }
}
